import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";
import { ConfigItem } from "../../types/api/configurations.type";
import { BreadcrumbItem } from "../../types/AppTypes";
import { OrgSettings } from "../../types/api/org.type";

export interface InitialStateProps {
  config: ConfigItem[];
  orgSettings: OrgSettings;
  breadcrumb: BreadcrumbItem[];
}

export const initialState: InitialStateProps = {
  config: [],
  breadcrumb: [],
  orgSettings: {
    areaList: {
      all: [],
      filtered: [],
    },
    collaborator: {
      internalGrades: [],
    },
    courses: {
      categories: [],
      typologies: [],
      executionModes: [],
    },
    certifications: {
      categories: [],
      executionModes: [],
      status: [],
    },
    cmsheet: {
      status: [],
    },
    userRoles: {
      role: [],
    },
    languageSkills: {
      languages: [],
    },
    techSkills: {
      levels: [],
    },
  },
};

export const configSlice = createSlice({
  name: "config",
  initialState,
  reducers: {
    setConfig: (
      state: InitialStateProps,
      action: PayloadAction<ConfigItem[]>,
    ) => {
      state.config = action.payload;
    },
    setBreadcrumb: (
      state: InitialStateProps,
      action: PayloadAction<BreadcrumbItem[]>,
    ) => {
      state.breadcrumb = action.payload;
    },
    setOrgSettings: (
      state: InitialStateProps,
      action: PayloadAction<OrgSettings>,
    ) => {
      state.orgSettings = action.payload;
    },
    resetConfigState: () => initialState,
  },
});

export const { setConfig, setBreadcrumb, setOrgSettings, resetConfigState } =
  configSlice.actions;
export default configSlice.reducer;
